import { Typography } from 'antd'
import styled from 'styled-components'

const StyledUpdatedText = styled(Typography.Text)`
  display: block;
  line-height: 24px;
`

export default StyledUpdatedText
